<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b] "> Administrator Page</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Form Request / Forms</p>
    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        <div class="flex items-center gap-5 mb-3">
            <h1 class="text-[#24723b] font-semibold text-lg">Search/Edit Forms</h1>
            <button v-on:click="HideView" class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3">+ Add Forms</button>
        </div>
        <div class="papsi-container w-[100%]">
            <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl :Action="true" :header="header" :column="column" :info="info" :EButton="true" :DButton="true" @EditButton="EditButton" @DeleteButton="DeleteButton"/>
            </div>
        </div>
    </div>
    <div v-if="FormModal">
        <div @click="FormModal = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#12760A] relative">
                <div class="pafcpic_header bg-[#12760A] py-3 px-6 ">
                    <p class="text-[#ffffff] text-md font-semibold">ADD FORMS</p>
                </div>
                <div class="pafcpic_body py-6 px-6">
                    
                    <input type="text"  placeholder="Form Name" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="formName">
                    
                    <select class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none mt-3" v-model="formStatus">
                        <option value="A" selected>ACTIVE</option>
                        <option value="I">INACTIVE</option>
                    </select>
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#0080002a] border-t font-medium">
                <button class="text-sm text-white bg-[#12760A] py-1.5 px-7 rounded-md" v-if="EditorAdd === 'Edit'" @click="Updateform">Update</button>
                <button class="text-sm text-white bg-[#12760A] py-1.5 px-7 rounded-md"  v-if="EditorAdd === 'Add'" @click="AddForms">Add</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md" v-on:click="FormModal = false">Cancel</button>
            </div>
        </div>
        </div>
    </div>

    <div v-if="Validation">
        <Prompt @CloseSignatory="Validation = false" type="VALIDATION"/>
    </div>

    <div v-if="addForm">
        <Prompt @CloseSignatory="addForm = false" type="ADDFORM"/>
    </div>
    <div v-if="editForm">
        <Prompt @CloseSignatory="editForm = false" type="EDITFORM"/>
    </div>
    
    <div v-if="Delete">
        <Prompt @CloseSignatory="Delete = false" type="DELETE"/>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import TableControl from '@/components/controls/TableControl/TableControl.vue'
import Services from '../../../services/admin'
import Prompt from '../Prompt/RequestPromt.vue'

    export default defineComponent ({
        components:{
                TableControl,
                Prompt
            },
        data(){
            return{
                editForm:   false,
                Delete:     false,
                addForm:    false,
                Validation: false,
                EditorAdd:  null,
                FormModal:  false,
                info:       null,
                TableView:  true,
                AddResponse: '',
                result:     '',
                updateid:   null,
                file:       '',
                formName:   '',
                formStatus: 'A',
                editID:     '',
                header:[
                    {
                        title:'No'
                    },
                    {
                        title:'Form Name'
                    },
                    {
                        title:'Form Status'
                    },
                    {
                        title:'Action'
                    },
                ],
                column:[
                    'index',
                    'form_name',
                    'form_status'
                ]
            }
        },
        mounted(){
            this.getForm()
        },
     methods:{
        onFileChange(e){
            this.file = e.target.files[0];
        },
        EditButton(row){
            this.result       = ''
            this.EditorAdd    = 'Edit'
            this.EditId       =  row.form_key
            this.formName     =  row.form_name
            this.formStatus   =  row.form_status
            this.FormModal    =  true
        },
        async DeleteButton(row){
            this.$emit("showLoader")
            const success    = await Services.deleteForm(row.form_key);
            this.AddResponse = success.data
            this.getForm()
            this.$emit("hideLoader")
            this.Delete = true
        },
        HideView(){
            this.EditId       =  ''
            this.formName     =  ''
            this.formStatus   =  'A'

            this.EditorAdd =  'Add'
            if (!this.TableView){
                this.FormModal = false
            }
            else{
                this.FormModal = true
            }
        },
        async AddForms(){
            if(!this.formName){
                this.Validation = true
                return
            }
            
            this.$emit("showLoader")
            const success = await Services.addForms(this.formName,this.formStatus);
            this.AddResponse = success.data
            this.FormModal = false
            this.getForm()
            this.$emit("hideLoader")
            this.addForm = true
        },
        async getForm(){
            this.$emit("showLoader")
            const success = await Services.getForms();
            this.info = success.data
            this.$emit("hideLoader")
        },
        async Updateform(){

            if(!this.formName){
                this.Validation = true
                return
            }
            this.$emit("showLoader")
            await Services.updateForms(this.EditId,this.formName,this.formStatus);
            this.FormModal = false
            this.getForm()
            this.$emit("hideLoader")
            this.editForm = true
        }
     },
    })
</script>
<style scoped>
.error{
    border:1px solid red;
}
.errorResult{
 background-color:red;
}
</style>
